import React from 'react';
import PropTypes from 'prop-types';

export default function SadFace({ size }) {
  const classes = 'display-block';

  if (size === 'extraSmall' || size === 'small') {
    return (
      <svg className={classes} width="10" height="10" viewBox="0 0 10 10">
        <path d="M5,0A5,5,0,0,0,0,5a5,5,0,0,0,5,5,5,5,0,0,0,5-5A5,5,0,0,0,5,0ZM3.5,3a.47.47,0,0,1,.5.5.47.47,0,0,1-.5.5A.47.47,0,0,1,3,3.5.47.47,0,0,1,3.5,3ZM6.9,6.8c-.1.2-.3.2-.5.2l-.1-.1A1.42,1.42,0,0,0,5,6a2.85,2.85,0,0,0-1.4.8c-.1.1-.2.2-.3.2L3,6.9a.48.48,0,0,1,0-.7A3.11,3.11,0,0,1,4.9,5.1,2.37,2.37,0,0,1,6.8,6.2C7,6.3,7,6.6,6.9,6.8ZM6.5,4A.47.47,0,0,1,6,3.5a.5.5,0,0,1,1,0A.47.47,0,0,1,6.5,4Z" />
      </svg>
    );
  } else if (size === 'extraLarge') {
    return (
      <svg className={classes} width="20" height="20" viewBox="0 0 20 20">
        <path d="M10,0A10,10,0,1,0,20,10,10,10,0,0,0,10,0ZM7,5A2,2,0,1,1,5,7,2,2,0,0,1,7,5Zm7.69,9.69a.94.94,0,0,1-1.33,0l0,0A4.52,4.52,0,0,0,10.09,13a5.41,5.41,0,0,0-3.41,1.61.94.94,0,0,1-1.33,0l0,0a1.05,1.05,0,0,1,0-1.44A7.27,7.27,0,0,1,10,11a6.3,6.3,0,0,1,4.67,2.22,1.05,1.05,0,0,1,0,1.46ZM13,9a2,2,0,1,1,2-2A2,2,0,0,1,13,9Z" />
      </svg>
    );
  }

  return (
    <svg className={classes} width="16" height="16" viewBox="0 0 16 16">
      <path d="M8,0a8,8,0,1,0,8,8A8,8,0,0,0,8,0ZM5.49,4A1.51,1.51,0,1,1,4,5.53,1.51,1.51,0,0,1,5.49,4Zm6.28,7.77a.78.78,0,0,1-1.09,0,3.7,3.7,0,0,0-2.6-1.23,4.42,4.42,0,0,0-2.73,1.21.78.78,0,0,1-1.09,0,.76.76,0,0,1,0-1.07A5.94,5.94,0,0,1,8,9a5.18,5.18,0,0,1,3.74,1.67.76.76,0,0,1,0,1.07ZM10.5,7A1.51,1.51,0,1,1,12,5.48,1.51,1.51,0,0,1,10.5,7Z" />
    </svg>
  );
}

SadFace.propTypes = {
  size: PropTypes.string,
};

SadFace.defaultProps = {
  size: 'medium',
};



// WEBPACK FOOTER //
// ./packages/marvel-ui-button/icons/SadFace.js